import useTenantScope from 'LearningManager/hooks/useTenantScope';

export const useAudienceTenantId = (tenantId?: number) => {
	const { canSelectTenant, scopedTenant } = useTenantScope();

	const audienceTenantId =
		tenantId ??
		(canSelectTenant ? undefined : Number(scopedTenant) || undefined);

	return {
		tenantId: audienceTenantId,
		isTenantResolved: canSelectTenant || Boolean(audienceTenantId)
	};
};

export default useAudienceTenantId;
